// frontend/src/actions/adminActions.js
import axios from "../utilities/axiosInstance";
import {
  ADMIN_DATA_REQUEST,
  ADMIN_DATA_SUCCESS,
  ADMIN_DATA_FAIL,
} from "../constants/adminConstants";

export const fetchAdminData = () => async (dispatch, getState) => {
  try {
    console.log("AdminActions: Dispatching ADMIN_DATA_REQUEST");
    dispatch({ type: ADMIN_DATA_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    console.log(
      "AdminActions: Fetching admin data with token:",
      userInfo.token
    );
    const { data } = await axios.get("/projects/all", {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });
    console.log("AdminActions: ADMIN_DATA_SUCCESS payload:", data);

    dispatch({ type: ADMIN_DATA_SUCCESS, payload: data });
  } catch (error) {
    console.error("AdminActions Error:", error);
    dispatch({
      type: ADMIN_DATA_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
